export default class Cost {
    static fromData(data) {
        if (!data) {
            return;
        }

        const cost = new Cost();
        cost.id = data.id;
        cost.title = data.title;
        cost.chargeLevels = data.chargeLevels;
        cost.category = data.category;

        return cost;
    }
}
